import { BuilderPlugin } from '@form-engine/builder-application';
import * as translations from './builder-translations';
import BsoFormMaskExtension from './components/form-mask-extension';

export interface BsoThemeDefinition {
    name?: string;
    className?: string;
}

// https://www.merixstudio.com/blog/typescript-declaration-merging/
declare module '@form-engine/builder-application/index' {
    interface IBuilder {
        bsoThemes?: Record<string, BsoThemeDefinition>;
    }
}

export default {
    translations,
    bsoThemes: {
        FlowApp: {
            className: 'fet-flowapp',
        },
        Bdp: {
            className: 'fet-bdp',
        },
        Portal: {
            className: 'fet-portal',
        },
        PortalGray: {
            className: 'fet-portal-gray',
        },
    },
    componentExtensions: {
        BuilderFormMask: {
            BsoFormMaskExtension: {
                placement: 'after',
                component: BsoFormMaskExtension,
            },
        },
    },
    maskConfigurations: {
        BuilderFormMask: {
            edit: {
                permissions: {
                    bsoEnvironment: 'write',
                    bsoAuth: 'write',
                    bsoBasicAuthUsername: 'write',
                    bsoBasicAuthPassword: 'write',
                    bsoBearerToken: 'write',
                },
            },
            preview: {
                permissions: {
                    bsoEnvironment: 'write',
                    bsoAuth: 'write',
                    bsoBasicAuthUsername: 'write',
                    bsoBasicAuthPassword: 'write',
                    bsoBearerToken: 'write',
                },
            },
            translate: {
                permissions: {
                    bsoEnvironment: 'read',
                    bsoAuth: 'read',
                    bsoBasicAuthUsername: 'read',
                    bsoBasicAuthPassword: 'read',
                    bsoBearerToken: 'read',
                },
            },
        },
    },
} as BuilderPlugin;
